(ns frontend.view.reports.custom.diamond-edge-styles)

(defn relative
  []
  {:position "relative"})

(defn select-style
  []
  {:min-width "200px"})

(defn date-ranges-selector
  []
  {:max-width "190px"})

(defn h-padding-after
  []
  {:padding-right "16px"})

(defn h-padding-both
  []
  {:padding-right "16px"
   :padding-left  "16px"})

(defn title-and-input-container
  []
  {:display        "flex"
   :flex-direction "column"
   ;:width          "190px"
  })

(defn date-range-container
  []
  {:display     "flex"
   :margin      "15px 0px"
   :align-items "end"})

(defn arrow-icon
  []
  ^{:combinators {[:> :div] {:cursor "default"}}}
  {:margin "10px 20px"
   :color  "grey"})
